<template>
  <li>
    <div class="accordion box">
      <button class="btn-accordion btn-open-modal" :class="{ 'btn-collapsetomodal': hasArrowIcon }"
        data-open="modalDetailService" ref="btn">
        <span class="btn-content">
          <span>{{ serviceTitle }}</span>
          <span v-if="hasNumberServices" class="number-services">{{ `${serviceNumber} SERVICE${serviceNumber > 1 ? 'S' :
            ''}`
          }}</span>
        </span>
      </button>
    </div>
  </li>
</template>

<script>
import {
  ref,
} from 'vue';

export default {
  props: {
    serviceTitle: { type: String, default: '' },
    serviceNumber: { type: Number, default: 1 },
    hasNumberServices: { type: Boolean, default: true },
    hasArrowIcon: { type: Boolean, default: false },
  },
  setup(props, { expose }) {
    const btn = ref(null);
    const focusBtn = () => {
      btn.value.focus();
    };
    expose({ focusBtn });
    return {
      btn,
    };
  },

};
</script>
